export const complianseSteps = [
  {
    element: '#compliancefilter',
    popover: {
      title: 'Select Date Range & Surgery Type',
      showButtons: ['next', 'close'],
      description:
        '<div><li> At the top, choose the time span (e.g., 2 weeks) and surgery type (e.g., Knee) to filter patient compliance data.</li> </div>',
    },
  },
  {
    element: '#compliancecharts',
    popover: {
      title: 'Review Compliance Charts',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div> <li>View color‐coded pie charts for Exercises, Measurements, and Questionnaires, showing Skipped, Partially Completed, and Completed counts.</li></div>',
    },
  },
  {
    element: '#complianceoverall',
    popover: {
      title: 'Check Overall Totals',
      showButtons: ['previous', 'next', 'close'],
      description:
        '<div><li> The “Overall” chart summarizes combined compliance across all tasks.</li></div>',
    },
  },
]
